import React from 'react';
import { Typography } from 'antd';

const { Title, Text } = Typography;

const GetTitle = () => {
  return (
    <>
      <Title level={2}>Choose a delivery address</Title>
      <Text> Multiple addresses in this location</Text>
    </>
  );
};

export default GetTitle;
